// The active notice types (notice_types — Utilities → Table Management → Notice Types), in their set order. The
// reports' Notices option offers one chip per type, whether or not any row has one yet (step 8).
// → { ok: true, data: [{ key, name }] } or { ok: false, error }
import { supabase } from '../supabase';

export async function loadActiveNoticeTypes() {
  const { data, error } = await supabase.from('notice_types').select('key, name, sort').eq('active', true);
  if (error) return { ok: false, error: `Notice types could not be loaded: ${error.message}` };
  return { ok: true, data: [...(data || [])].sort((a, b) => (a.sort - b.sort) || a.name.localeCompare(b.name)).map(({ key, name }) => ({ key, name })) };
}
